(function () {
  'use strict';
  if (window.__hotpotShopCart) return;
  window.__hotpotShopCart = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-shop-add]');
    if (!btn || btn.disabled) return;
    var original = btn.textContent;
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: btn.dataset.variantId, quantity: 1 }], sections: 'cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || btn.dataset.error); return j; }); })
      .then(function (j) {
        var html = j.sections && j.sections['cart-icon-bubble'];
        var target = document.getElementById('cart-icon-bubble');
        if (html && target) {
          var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (src) target.innerHTML = src.innerHTML;
        }
        btn.textContent = btn.dataset.added;
      })
      .catch(function (err) { btn.textContent = btn.dataset.error; console.error(err); })
      .then(function () { setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2200); });
  });
})();